import getConfig from 'next/config';

export const isNAStore = () => {
  const { publicRuntimeConfig } = getConfig();
  const storeRegion = publicRuntimeConfig.STORE_REGION;
  return storeRegion === 'NA';
};

export const isEMEAStore = () => {
  const { publicRuntimeConfig } = getConfig();
  const storeRegion = publicRuntimeConfig.STORE_REGION;
  return storeRegion === 'EMEA';
};

export const isLATAMStore = () => {
  const { publicRuntimeConfig } = getConfig();
  const storeRegion = publicRuntimeConfig.STORE_REGION;
  return storeRegion === 'LATAM';
};

export const isGCCStore = () => {
  const { publicRuntimeConfig } = getConfig();
  const storeRegion = publicRuntimeConfig.STORE_REGION;
  return storeRegion === 'GCC';
};

export const isAPACStore = () => {
  const { publicRuntimeConfig } = getConfig();
  const storeRegion = publicRuntimeConfig.STORE_REGION;
  return storeRegion === 'APAC';
};
